import { Viewer, Worker } from "@react-pdf-viewer/core";
import { useEffect, useState } from "react";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "antd";
import { StepBackwardOutlined } from "@ant-design/icons";
import { usePDFStore } from "../Idb";

export const SingleBook = () => {
    let [pdfurl, setPdfurl] = useState([''])
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    let { getPDFByIdFromIndexedDB } = usePDFStore()
    let params = useParams()
    let navigate = useNavigate()
    useEffect(() => {
        let id = Number(params.id)
        getPDFByIdFromIndexedDB(id).then(res => {
            let url = URL.createObjectURL(res.blob)
            setPdfurl(url)
        })
    }, []);


    return (
        <>
            <Button type={'primary'} shape={'circle'} icon={<StepBackwardOutlined />}
                style={{
                    position: 'fixed',
                    bottom: '15px',
                    left: '15px',
                    zIndex: '99999'
                }}
                size={'large'}
                onClick={() => navigate('/mybooks')}
            />
            {pdfurl && (
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                    <Viewer characterMap={{
                        isCompressed: false,
                        url: 'https://unpkg.com/pdfjs-dist@3.11.174/cmaps/',
                    }} fileUrl={pdfurl} plugins={[defaultLayoutPluginInstance]} />
                </Worker>
            )}
        </>
    )
}